import { actionTypes } from './GeneralFilterModal/constants';
import { getDefaultFilters } from './GeneralFilterModal/helpers';
import { apiCallStatus } from 'helpers/constants';


export const initialState = {
    organizations: {
        data: [],
        loadingStatus: null
    },
    sites: {
        data: [],
        loadingStatus: null
    },
    assetGroups: {
        data: [],
        loadingStatus: null
    },
    assets: {
        data: [],
        loadingStatus: null
    },
    selectedFilters: getDefaultFilters(),
    refeshCIAMSync: false,
    refreshPowertrains: false,
    refreshAssetGroups: false,
    refreshAssets: false,
    contextLoadingStatus: apiCallStatus.SUCCESS,
    lastSelectedOrganization: {
        data: {},
        error: null,
        loadingStatus: null
    },
    ciamSearchOrganization: {
        data: {},
        loadingStatus: null,
        error: null
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ASSETS: {
            return {
                ...state,
                assets: {
                    data: action.data,
                    loadingStatus: action.loadingStatus
                }
            };
        }
        case actionTypes.GET_POWERTRAINS: {
            return {
                ...state,
                powertrains: action
            };
        }
        case actionTypes.GET_ORGANIZATIONS: {
            return {
                ...state,
                organizations: { ...state.organizations, ...action }
            };
        }
        case actionTypes.GET_SITES: {
            return {
                ...state,
                sites: {
                    ...state.sites,
                    loadingStatus: action.loadingStatus,
                    data: action.data
                }
            };
        }
        case actionTypes.GET_ASSET_GROUPS: {
            return {
                ...state,
                assetGroups: { ...state.assetGroups, ...action }
            };
        }
        case actionTypes.SET_SELECTED_FILTERS: {
            return {
                ...state,
                selectedFilters: { ...state.selectedFilters, ...action.selectedFilters }
            };
        }
        case actionTypes.UPDATE_REFRESH_DATA_FLAG: {
            return {
                ...state,
                refreshPowertrains: true,
                refreshAssetGroups: true,
                refreshAssets: true
            };
        }
        case actionTypes.SET_RELOAD_CONTEXT_LOADING_STATUS: {
            return {
                ...state,
                contextLoadingStatus: action.loadingStatus
            };
        }
        case actionTypes.SET_CIAM_SYNC_FLAG: {
            return {
                ...state,
                refeshCIAMSync: action.refeshCIAMSync
            };
        }
        case actionTypes.SET_CIAM_SYNC_AND_REFRESH_FLAG: {
            return {
                ...state,
                refeshCIAMSync: action.refeshAndCIAMSync,
                refreshPowertrains: action?.refeshAndCIAMSync ? true : state.refreshPowertrains,
                refreshAssetGroups: action?.refeshAndCIAMSync ? true : state.refreshAssetGroups,
                refreshAssets: action?.refeshAndCIAMSync ? true : state.refreshAssets
            };
        }
        case actionTypes.SET_POWERTRAIN_SYNC_FLAG: {
            return {
                ...state,
                refreshPowertrains: false
            };
        }
        case actionTypes.SET_ASSET_GROUP_SYNC_FLAG: {
            return {
                ...state,
                refreshAssetGroups: false
            };
        }
        case actionTypes.SET_ASSETS_SYNC_FLAG: {
            return {
                ...state,
                refreshAssets: false
            };
        }
        case actionTypes.GET_LAST_SELECTED_ORGANIZATION: {
            return {
                ...state,
                lastSelectedOrganization: {
                    data: action?.loadingStatus === apiCallStatus.SUCCESS ? action?.data : state.lastSelectedOrganization?.data,
                    error: action?.error,
                    loadingStatus: action?.loadingStatus
                }
            };
        }
        default:
            return state;
    }
};

export default reducer;
